import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import gridCSS from '../styles/grid'

// const host = 'http://localhost:2131'
const host = ''

interface IPeriod {
    startDate: string;
    endDate: string;
}

interface IAgent {
    label: string;
    value: string;
}

interface ISources {
    history: {
        sessions: string;
        questions: string;
        topics: string;
    },
    stats: {
        overall : string;
        sessions: string;
        emotions: string;
        sentiment: string;
    }
}

@customElement('vxv-dashboard')
export class TDashboard extends LitElement {
    static styles = [
        css `
        :host {
            display: block;
            margin: 0px; 
            padding: 0px;
            width: 99vw;
            height: 100%;
        }
        .dashboard-item {
            border: 0px solid #dee2e6;
            padding: 0rem;
            height: 100%;
            background: white;
            overflow: auto;
        }
        .sessions-day {
            height: 25rem;
        }
        .topics {
            height: 50rem;
        }
        .emotions {
            height: 25rem;
        }
        .sentiment {
            height: 25rem;
        }
        .sessions-log {
            height: 50rem;
        }   
        `,
        gridCSS ];

    setAgent = this._setAgent.bind(this) as EventListener
    setPeriod = this._setPeriod.bind(this) as EventListener

    @property({ type: Object }) agent?: IAgent;
    @property({ type: Object }) period?: IPeriod;

    private _setAgent(event: CustomEvent<IAgent>) {
        console.log('setting agent', event?.detail)
        this.agent = event.detail
    }

    private _setPeriod(event: CustomEvent<IPeriod>) {
        console.log('setting period', event.detail)
        this.period = event.detail
    }

    connectedCallback(): void {
        super.connectedCallback()
        document.addEventListener('agent.set' , this.setAgent)
        document.addEventListener('period.set', this.setPeriod)

        var agent : IAgent  = {label: 'ChatBot', value:'f5d9466c-14e5-4cf4-aa6b-db7f56fab9de'}
        var period: IPeriod = {startDate: new Date().toISOString().split('T')[0], endDate: new Date().toISOString().split('T')[0]}
        const storage = {
            agent  : (sessionStorage.getItem('agent')||'').split(':'),
            start  : sessionStorage.getItem('period.startDate') || new Date().toISOString().split('T')[0],
            end    : sessionStorage.getItem('period.endDate')    
        }
        if(storage.agent.length)    agent  =  { label: storage.agent[0], value: storage.agent[1] }
        period = { startDate: storage.start, endDate: storage.end || storage.start }

        this.agent = agent
        this.period = period
        console.log('sessionStorage', storage)
        console.log('this.agent', agent)
        console.log('this.period', period)
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        // Remove the event listener to prevent memory leaks
        document.removeEventListener('agent.set' , this.setAgent);
        document.removeEventListener('period.set', this.setPeriod);
    }

    renderCall() {
        console.log('CHAT.render', this.period, this.agent)
        const tables = {
            sessions: { 
                columns: [
                    {"title": "Appelant", "data": "caller", "width": "20ch"},
                    {"title": "date", "data": "date", "type": "date", "width": "30ch"},
                    {"title": "durée", "data": "duration", "width": "5ch", "render": "${data} mn"},
                    {"title": "question", "data": "question"}
                ],
                itemView: '<p>${item.dialog.map(u=>`${md2html(`**${u.role}**: ${u.content.trim()}`)}`).join("")}</p>'
            },
            topics: {
                columns: [
                    {"title": "Sujet", "data": "topic"},
                    {"title": "Fréqence", "data": "count"}
                ]
            }
        }
        let sources: ISources = {history: {sessions: '', questions: '', topics: ''}, stats: {overall: '', sessions: '', emotions: '', sentiment:''}}
        if(this.agent && this.period) {
            sources.history.sessions  = `${host}/apps/${this.agent.value}/history/sessions?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
            sources.history.questions = `${host}/apps/${this.agent.value}/history/questions?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
            sources.history.topics    = `${host}/apps/${this.agent.value}/history/topics?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
            sources.stats.overall     = `${host}/apps/${this.agent.value}/stats/overall?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
            sources.stats.sessions    = `${host}/apps/${this.agent.value}/stats/sessions?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
            sources.stats.emotions    = `${host}/apps/${this.agent.value}/stats/emotions?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
            sources.stats.sentiment   = `${host}/apps/${this.agent.value}/stats/sentiment?from=${this.period.startDate}&to=${this.period.endDate}&type=call`
        }
        
        return html`
        <vxw-menu
            name="${this.agent?.label||'BOT'}"
        ></vxw-menu>
        <div class="container-fluid p-2 pt-5 mt-5">
            <div class="row g-4">
                <vxc-valuelist
                    source=${sources.stats.overall}
                ></vxc-valuelist>
            </div>
            <div class="row g-4">
                <!-- Top row -->
                <div class="col-12 col-lg-6 h-100">
                    <div class="dashboard-item sessions-day">

                        <vxc-widget
                            title="Nombre d'appels">
                            <vxc-chart
                                type="bar"
                                title="Nombre d'appels"
                                sub-title=""
                                source=${sources.stats.sessions}
                                >
                            </vxc-chart>
                        </vxc-widget>

                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6 h-100">
                    <div class="dashboard-item sentiment">

                        <vxc-widget
                            title="Sentiment Général">
                            <vxc-chart
                                type="gauge"
                                title=""
                                sub-title=""
                                source=${sources.stats.sentiment}
                                >
                            </vxc-chart>
                        </vxc-widget>                        

                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6 h-100">
                    <div class="dashboard-item emotions">

                        <vxc-widget
                            title="Emotions">
                            <vxc-chart
                                type="pie"
                                title=""
                                sub-title=""
                                source=${sources.stats.emotions}
                                >
                            </vxc-chart>
                        </vxc-widget>

                    </div>
                </div>
                
                <!-- Bottom row -->
                <div class="row g-4">
                    <div class="col-9">
                        <div class="dashboard-item sessions-log">
                            <!--h5 class="m-0">Sessions Log</h5-->

                            <vxc-widget
                                title="Liste de sessions">
                                <vxc-datatable style="height: 100vh;"
                                    columns=${JSON.stringify(tables.sessions.columns)}
                                    item-title='caller'
                                    item-view=${tables.sessions.itemView}
                                source=${sources.history.sessions}
                                ></vxc-datatable>
                            </vxc-widget>

                        </div>
                    </div>
                    <div class="col-3">
                        <div class="dashboard-item topics">

                            <vxc-widget
                                title="Sujets de conversations">
                                <vxc-datatable style="height: 100vh;"
                                    columns=${JSON.stringify(tables.topics.columns)}
                                    source=${sources.history.topics}
                                ></vxc-datatable>
                            </vxc-widget>                        

                        </div>
                    </div>
                </div>
            </div>
         </div>`
    }
    
    // render function
    renderChat() {
        console.log('CHAT.render', this.period, this.agent)
        const tables = {
            sessions: { 
                columns: [
                    {"title": "ID", "data": "uid", "width": "36ch"},
                    {"title": "date", "data": "date", "type": "date", "width": "20ch"},
                    {"title": "", "data": "eval", "width": "1ch"},
                    {"title": "question", "data": "question"}
                ],
                itemView: '<p>${item.dialog.map(u=>`${md2html(`**${u.role}**: ${u.content.trim()}`)}`).join("")}</p>'
            },
            topics: {
                columns: [
                    {"title": "Sujet", "data": "topic"},
                    {"title": "Fréqence", "data": "count"}
                ]
            }
        }
        let sources: ISources = {history: {sessions: '', questions: '', topics: ''}, stats: {overall: '', sessions: '', emotions: '', sentiment:''}}
        if(this.agent && this.period) {
            sources.history.sessions  = `${host}/apps/${this.agent.value}/history/sessions?from=${this.period.startDate}&to=${this.period.endDate}`
            sources.history.questions = `${host}/apps/${this.agent.value}/history/questions?from=${this.period.startDate}&to=${this.period.endDate}`
            sources.history.topics    = `${host}/apps/${this.agent.value}/history/topics?from=${this.period.startDate}&to=${this.period.endDate}`
            sources.stats.overall     = `${host}/apps/${this.agent.value}/stats/overall?from=${this.period.startDate}&to=${this.period.endDate}`
            sources.stats.sessions    = `${host}/apps/${this.agent.value}/stats/sessions?from=${this.period.startDate}&to=${this.period.endDate}`
            sources.stats.emotions    = `${host}/apps/${this.agent.value}/stats/emotions?from=${this.period.startDate}&to=${this.period.endDate}`
            sources.stats.sentiment   = `${host}/apps/${this.agent.value}/stats/sentiment?from=${this.period.startDate}&to=${this.period.endDate}`
        }
        
        return html`
        <vxw-menu
            name="${this.agent?.label||'BOT'}"
        ></vxw-menu>
        <div class="container-fluid p-2 pt-5 mt-5">
            <div class="row g-4">
                <vxc-valuelist
                    source=${sources.stats.overall}
                ></vxc-valuelist>
            </div>
            <div class="row g-4">
                <!-- Top row -->
                <div class="col-12 col-lg-6 h-100">
                    <div class="dashboard-item sessions-day">

                        <vxc-widget
                            title="Nombre de sessions">
                            <vxc-chart
                                type="bar"
                                title="Nombre de questions"
                                sub-title=""
                                source=${sources.stats.sessions}
                                >
                            </vxc-chart>
                        </vxc-widget>

                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6 h-100">
                    <div class="dashboard-item sentiment">

                        <vxc-widget
                            title="Sentiment Général">
                            <vxc-chart
                                type="gauge"
                                title=""
                                sub-title=""
                                source=${sources.stats.sentiment}
                                >
                            </vxc-chart>
                        </vxc-widget>                        

                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6 h-100">
                    <div class="dashboard-item emotions">

                        <vxc-widget
                            title="Emotions">
                            <vxc-chart
                                type="pie"
                                title=""
                                sub-title=""
                                source=${sources.stats.emotions}
                                >
                            </vxc-chart>
                        </vxc-widget>

                    </div>
                </div>
                
                <!-- Bottom row -->
                <div class="row g-4">
                    <div class="col-9">
                        <div class="dashboard-item sessions-log">
                            <!--h5 class="m-0">Sessions Log</h5-->

                            <vxc-widget
                                title="Liste de sessions">
                                <vxc-datatable style="height: 100vh;"
                                    columns=${JSON.stringify(tables.sessions.columns)}
                                    item-title='uid'
                                    item-view=${tables.sessions.itemView}
                                source=${sources.history.sessions}
                                ></vxc-datatable>
                            </vxc-widget>

                        </div>
                    </div>
                    <div class="col-3">
                        <div class="dashboard-item topics">

                            <vxc-widget
                                title="Sujets de conversations">
                                <vxc-datatable style="height: 100vh;"
                                    columns=${JSON.stringify(tables.topics.columns)}
                                    source=${sources.history.topics}
                                ></vxc-datatable>
                            </vxc-widget>                        

                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }

    render() {
        var name = this.agent?.label||'BOT'
        return name === 'CallBot' ? this.renderCall() : this.renderChat()
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxv-dashboard': TDashboard;
  }
}